import { useLang } from "../i18n";

const keywords = [
  ["mq.1", "Space-Time"],
  ["mq.2", "Particle Physics"],
  ["mq.3", "Quantum Mechanics"],
  ["mq.4", "AI Computing"],
  ["mq.5", "Biology"],
  ["mq.6", "Neurology"],
  ["mq.7", "Psychology"],
  ["mq.8", "Cognitive Science"],
  ["mq.11", "Health Sciences"],
  ["mq.12", "Medical Science"],
  ["mq.9", "Longevity"],
  ["mq.10", "150+ Years"],
];

const Marquee = () => {
  const { t } = useLang();
  const row = [...keywords, ...keywords];
  return (
    <div
      data-testid="keywords-marquee"
      className="relative overflow-hidden border-y border-white/5 bg-surface/60 py-6"
    >
      <div className="flex w-max animate-marquee gap-24 whitespace-nowrap">
        {row.map(([k, en], i) => (
          <span
            key={`${k}-${i}`}
            className={`flex items-center gap-24 font-mono text-base uppercase tracking-[0.3em] ${i % 2 === 0 ? "text-white/40" : "text-cyan-200/50"}`}
          >
            {t(k, en)}
            <span className="text-violet-300/30">◆</span>
          </span>
        ))}
      </div>
    </div>
  );
};

export default Marquee;
